// import React, { Component } from "react";
// import Slider from "react-slick";
// import { Link } from 'react-router-dom'
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// import hero1 from '../../images/slider/slide-1.jpg'
// import hero2 from '../../images/slider/slide-2.jpg'
// import hero3 from '../../images/slider/slide-3.jpg'
// import hero4 from '../../images/slider/slide-4.jpg'
// import hero5 from '../../images/slider/slide-5.jpg'



// class Hero extends Component {
//     render() {

//         var settings = {
//             dots: false,
//             arrows: true,
//             speed: 1200,
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             autoplay: true,
//             autoplaySpeed: 2500,
//             fade: true
//         };

//         return (
//             <section className={`wpo-hero-slider ${this.props.heroClass}`}>
//                 <div className="hero-container">
//                     <div className="hero-wrapper">
//                         <Slider {...settings}>
//                             <div className="hero-slide">
//                                 <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero1})` }}>
//                                     <div className="container-fluid">
//                                         <div className="slide-content">
//                                             <div className="slide-title">
//                                                 <h2>Protecting your Rights, Serving your Needs</h2>
//                                             </div>
//                                             <div className="slide-text">
//                                                 <p>We endeavor to provide our clients with a network of innovative legal solutions, excellent legal representation and a dedication to quality client service.</p>
//                                             </div>
//                                             <div className="clearfix"></div>
//                                             <div className="slide-btns">
//                                                 <Link to="/about" className="theme-btn">Get Started</Link>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="hero-slide">
//                                 <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero2})` }}>
//                                     <div className="container-fluid">
//                                         <div className="slide-content">
//                                             <div className="slide-title">
//                                                 <h2>Protecting your Rights, Serving your Needs</h2>
//                                             </div>
//                                             <div className="slide-text">
//                                                 <p>We endeavor to provide our clients with a network of innovative legal solutions, excellent legal representation and a dedication to quality client service.</p>
//                                             </div>
//                                             <div className="clearfix"></div>
//                                             <div className="slide-btns">
//                                                 <Link to="/about" className="theme-btn">Get Started</Link>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </Slider>
//                     </div>
//                 </div>
//             </section>
//         )
//     }
// }

// export default Hero;

import React, { Component } from "react";
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import hero1 from '../../images/slider/slide-1.jpg';
import hero2 from '../../images/slider/slide-2.jpg';
import hero3 from '../../images/slider/slide-3.jpg';
import hero4 from '../../images/slider/slide-4.jpg';
import hero5 from '../../images/slider/slide-5.jpg';

class Hero extends Component {
    render() {
        var settings = {
            dots: false,
            arrows: true,
            speed: 1200,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            fade: true
        };

        return (
            <section className={`wpo-hero-slider ${this.props.heroClass}`}>
                <div className="hero-container">
                    <div className="hero-wrapper">
                        <Slider {...settings}>
                            {/* Slide 1 */}
                            <div className="hero-slide">
                                <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero1})` }}>
                                    <div className="container-fluid">
                                        <div className="slide-content">
                                            <div className="slide-title">
                                                <h2>Protecting your Rights, Serving your Needs</h2>
                                            </div>
                                            <div className="slide-text">
                                                <p>We endeavor to provide our clients with a network of innovative legal solutions, excellent legal representation and a dedication to quality client service.</p>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="slide-btns">
                                                <Link to="/about" className="theme-btn">Get Started</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Slide 2 */}
                            <div className="hero-slide">
                                <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero2})` }}>
                                    <div className="container-fluid">
                                        <div className="slide-content">
                                            <div className="slide-title">
                                                <h2>Expert Guidance for Your Legal Challenges</h2>
                                            </div>
                                            <div className="slide-text">
                                                <p>Our experienced attorneys are here to navigate the complexities of your legal needs with personalized attention and care.</p>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="slide-btns">
                                                <Link to="/services" className="theme-btn">Explore Services</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Slide 3 */}
                            <div className="hero-slide">
                                <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero3})` }}>
                                    <div className="container-fluid">
                                        <div className="slide-content">
                                            <div className="slide-title">
                                                <h2>Committed to Justice and Excellence</h2>
                                            </div>
                                            <div className="slide-text">
                                                <p>Delivering unparalleled legal solutions to ensure fairness, equity, and client satisfaction in every case.</p>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="slide-btns">
                                                <Link to="/contact" className="theme-btn">Contact Us</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Slide 4 */}
                            <div className="hero-slide">
                                <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero4})` }}>
                                    <div className="container-fluid">
                                        <div className="slide-content">
                                            <div className="slide-title">
                                                <h2>Your Partner in Success</h2>
                                            </div>
                                            <div className="slide-text">
                                                <p>Let us empower your journey with effective legal counsel tailored to your unique goals and challenges.</p>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="slide-btns">
                                                <Link to="/about" className="theme-btn">Learn More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Slide 5 */}
                            <div className="hero-slide">
                                <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero5})` }}>
                                    <div className="container-fluid">
                                        <div className="slide-content">
                                            <div className="slide-title">
                                                <h2>Innovating Legal Solutions</h2>
                                            </div>
                                            <div className="slide-text">
                                                <p>Combining innovation and expertise to provide our clients with the best possible outcomes in any situation.</p>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="slide-btns">
                                                <Link to="/services" className="theme-btn">Our Expertise</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>
        );
    }
}

export default Hero;
